import {isAppLocale} from './config'

/** Moment.js locale id (month/day names). */
export function resolveMomentLocale(appLocale: string): string {
  return isAppLocale(appLocale) && appLocale === 'id' ? 'id' : 'en'
}

/** FullCalendar `locale` prop (must match an entry in `locales` array). */
export function resolveFullCalendarLocale(appLocale: string): string {
  return isAppLocale(appLocale) && appLocale === 'id' ? 'id' : 'en-gb'
}
